import React from "react";

import { Steward } from "components/Common/TableStyle";

export const CDE_COLUMN_DATA = [
  {
    dataIndex: "name",
    key: "name",
    title: "Name",
    width: "35%",
  },
  {
    dataIndex: "description",
    key: "description",
    title: "Description",
    render: text => <div className="whitespace-pre-line">{text}</div>,
    width: "65%",
  },
  {
    title: "Drafter",
    width: "35%",
    key: "drafter",
    dataIndex: "drafter",
    render: text => <Steward name={text?.name} title={text?.role} />,
  },
  {
    title: "Approver",
    width: "35%",
    key: "approver",
    dataIndex: "approver",
    render: text => <Steward name={text?.name} title={text?.role} />,
  },
  {
    title: "Secured CDE",
    dataIndex: "is_secured",
    key: "is_secured",
    width: 100,
    render: row => {
      if (row === "") return "No";
      else if (row === "phi") return "PHI";

      return "Business Sensitive";
    },
  },
  {
    dataIndex: "mapping_status",
    key: "mapping_status",
    title: "Mapping Status",
    width: 150,
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    dataIndex: "data_source_count",
    key: "data_source_count",
    title: "# Data Source",
    width: 100,
    render: text => (text ? text : 0),
  },
];
